var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZwa9A(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0721 46.0851C10.7708 44.878 6.26742 44.2691 1.89887 43.7113C0.95795 43.5944 0.08437 44.247 0.0171614 45.1664C-0.117256 46.0865 0.555224 46.9279 1.42893 47.0448C5.66307 47.5818 10.0312 48.1565 14.131 49.3185C15.0047 49.5705 15.946 49.0517 16.2148 48.1592C16.4836 47.2673 15.9458 46.3378 15.0721 46.0851Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1097 28.9722C21.1872 21.9079 13.3911 15.753 6.603 8.49917C5.99812 7.82171 4.92278 7.78541 4.2507 8.41785C3.57861 9.05095 3.51167 10.1155 4.18375 10.793C10.9718 18.0676 18.768 24.2428 25.6905 31.3279C26.3626 31.9892 27.4376 31.9986 28.1097 31.348C28.7146 30.6981 28.7818 29.6336 28.1097 28.9722Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0819 1.79978C41.2835 5.84304 41.4847 9.8863 41.6864 13.9302C41.6864 14.8564 42.4933 15.5715 43.4342 15.5264C44.3751 15.4807 45.0468 14.6924 45.0468 13.7656C44.8452 9.7156 44.6439 5.66628 44.4423 1.61697C44.3751 0.690833 43.5685 -0.0195612 42.6276 0.0308452C41.7538 0.0812516 41.0147 0.874315 41.0819 1.79978Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZwa9A);
export default __webpack_public_path__ + "static/media/zwa9a.dfc9375e11db6774adece060264ee80d.svg";
export { ForwardRef as ReactComponent };